module.exports = __webpack_public_path__ + "img/to_doctor_home.992281bb.png";